// extracted by mini-css-extract-plugin
export default {"p3":"style_p3__Fzc-v"};